<template>
  <div class="d-flex">
    <StatusChip
      :status="revStatus"
      :statusText="revStatusText"
      :availableStatus="availableStatus"
      :isEditable="canEdit"
      :large="large"
      :textClass="textClass"
      :color="color"
      :showValidationIcons="showValidationIcons"
      :isValidated="isRevValidatedStatus"
      :isFinanciallyValidated="isFinanciallyValidatedStatus"
      @onChange="handleSelectStatus"
    />
  </div>
</template>
<script>
import _ from 'lodash'
import revMixin from '@/mixins/rev.vue'
import constants from '@/constants'

import StatusChip from './StatusChip.vue'

export default {
  name: 'RevStatus',

  mixins: [revMixin],

  components: {
    StatusChip,
  },

  props: {
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
    rev: {
      type: Object,
      required: true,
    },
    canEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    isApproved: {
      type: Boolean,
      default: false,
    },
    showValidationIcons: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    revStatus() {
      return this.getRevStatus(this.rev)
    },

    revStatusText() {
      return this.getStatusText(this.revStatus)
    },

    isRevValidatedStatus() {
      return this.isRevValidated(this.rev)
    },

    isFinanciallyValidatedStatus() {
      return this.isFinanciallyValidated(this.rev)
    },

    availableStatus() {
      return _.compact([
        {
          value: constants.revStatus.open,
          text: this.getStatusText(constants.revStatus.open),
        },
        {
          value: constants.revStatus.inProgress,
          text: this.getStatusText(constants.revStatus.inProgress),
        },
        {
          value: constants.revStatus.completed,
          text: this.getStatusText(constants.revStatus.completed),
        },
        {
          value: constants.revStatus.onHold,
          text: this.getStatusText(constants.revStatus.onHold),
        },
        {
          value: constants.revStatus.canceled,
          text: this.getStatusText(constants.revStatus.canceled),
        },
      ])
    },

    color() {
      switch (this.revStatus) {
        case constants.revStatus.open:
          return 'teal lighten-2'
        case constants.revStatus.inProgress:
          return 'blue lighten-2'
        case constants.revStatus.inReview:
          return 'blue-grey lighten-2'
        case constants.revStatus.canceled:
          return 'blue-grey darken-2'
        case constants.revStatus.onHold:
          return 'yellow lighten-2'
        case constants.revStatus.completed:
          return 'green lighten-2'
        case constants.revStatus.validated:
        case constants.revStatus.financiallyValidated:
        case constants.revStatus.impactValidated:
          return 'teal lighten-2'
        default:
          return ''
      }
    },

    textClass() {
      switch (this.revStatus) {
        case constants.revStatus.open:
          return 'teal--text text--darken-2'
        case constants.revStatus.inProgress:
          return 'blue--text text--darken-1'
        case constants.revStatus.inReview:
          return 'blue-grey--text text--darken-3'
        case constants.revStatus.canceled:
          return 'blue-grey--text text--lighten-3'
        case constants.revStatus.completed:
          return 'green--text text--darken-2'
        case constants.revStatus.onHold:
          return 'yellow--text text--darken-1'
        case constants.revStatus.validated:
        case constants.revStatus.financiallyValidated:
        case constants.revStatus.impactValidated:
          return 'teal--text text--darken-2'
        default:
          return ''
      }
    },
  },

  methods: {
    getStatusText(status) {
      return this.$t(
        `common.rev_condition.${this.getStatusTranslationKey(status)}`
      )
    },

    getStatusTranslationKey(status) {
      return _.snakeCase(status)
    },

    handleSelectStatus(status) {
      if (this.readOnly) return
      this.$emit('onChange', status)
    },
  },
}
</script>
